import { PayPalButtons } from "@paypal/react-paypal-js";
import localeText from "../../locale";
import OrderService from "../../service/OrderService";
import { removelocalStorageToken } from "../../utilities/sessionStorage/token";
import { removelocalStorageUsername } from "../../utilities/sessionStorage/username";
import { useHistory, useLocation } from "react-router-dom";
import IntegrationService from "../../service/IntegrationService";
import AdvancedPayPalService from "../../service/AdvancedPayPalService";
import { useRef, useState, useEffect, useCallback, useMemo } from "react";
import GetUserInfoService from "../../service/GetUserInfoService";
import { usePayment } from "../../pages/ShoppingCart/components/Checkout/context/PaymentContext";
import { useContext } from "react";
import { CartContext } from "../../contexts/CartContext/CartContext";

const PayPalButtonsOnly = (props) => {
  const location = useLocation();
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);

  const isFringeBenefitsPage = location?.pathname?.toLowerCase()?.includes("fringe");

  const orderKey = isFringeBenefitsPage
    ? "__extraconomy_order_fringe_benefit"
    : "__extraconomy_order";

  const {
    setDisplayPaymentModal,
    setIdTransaction,
    priceOriginal,
    toast,
    userCurrency,
    price: propsPrice,
  } = props;
  const {
    setPage,
    address,
    city,
    country,
    district,
    number,
    postalCode,
    state,
    amountWallet,
    amountToPayWithExtracredit,
    amountBankTransfer,
    order: contextOrder,
    calculateTotalPrice,
  } = usePayment();
  const { clearCart } = useContext(CartContext);

  const latestAmountWallet = useRef(amountWallet || 0);
  const latestAmountToPayWithExtracredit = useRef(amountToPayWithExtracredit || 0);
  const latestAmountBankTransfer = useRef(amountBankTransfer || 0);

  if (amountWallet !== latestAmountWallet.current) {
    latestAmountWallet.current = amountWallet || 0;
  }
  if (amountToPayWithExtracredit !== latestAmountToPayWithExtracredit.current) {
    latestAmountToPayWithExtracredit.current = amountToPayWithExtracredit || 0;
  }
  if (amountBankTransfer !== latestAmountBankTransfer.current) {
    latestAmountBankTransfer.current = amountBankTransfer || 0;
  }

  const price = propsPrice || priceOriginal || 0;

  const Navigate = useHistory();
  const order = contextOrder || JSON.parse(localStorage.getItem(orderKey) || 'null');

  useEffect(() => {}, [
    order,
    propsPrice,
    priceOriginal,
    price,
    address,
    city,
    country,
    district,
    number,
    postalCode,
    state,
  ]);

  const orderService = useMemo(() => new OrderService(), []);
  const advancedPayPalService = useMemo(() => new AdvancedPayPalService(), []);
  const integrationService = useMemo(() => new IntegrationService(), []);
  const getUserInfoService = useMemo(() => new GetUserInfoService(), []);

  const orderId = useRef(null);
  const [isPaying, setIsPaying] = useState(false);
  const initialPrice = useRef(price);
  const latestPrice = useRef(price);
  latestPrice.current = price;

  if (price > 0 && price !== initialPrice.current) {
    initialPrice.current = price;
  }

  const finishOrder = useCallback(
    async (transactionID) => {
      async function sendPurchase() {
        let dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "Purchase",
        });
        const user = await getUserInfoService.getUserInfo(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username")
        );
        let ip = await integrationService.getUserIp();
        let date = new Date();
        let payload = {
          eventData: {
            currency: userCurrency,
            value: price,
          },
          eventName: "Purchase",
          eventTime: Math.floor(date.getTime() / 1000),
          userData: {
            email: user.result.user?.email ? user.result.user.email : "",
            ipAddress: ip.data.ip,
            phone: user.result.user?.phoneNumber ? user.result.user.phoneNumber : "",
            userAgent: window.navigator.userAgent,
          },
        };
        let res = await integrationService.sendEvent(payload);
        return res;
      }
      let amountBankTransfer = parseFloat((latestAmountBankTransfer.current || 0).toFixed(2));
      try {
        props.setLoading(true);

        let res;

        if (isFringeBenefitsPage) {
          res = await orderService.postFinishFringeBenefitOrder(
            amountWallet ?? 0,
            parseFloat(
              (props?.amountToPayWithExtracredit ? props?.amountToPayWithExtracredit : 0).toFixed(2)
            ),
            amountBankTransfer,
            props?.bankTransferReceipt,
            order?.id,
            transactionID,
            price
          );
        } else {
          const totalOrder = calculateTotalPrice();
          const amountWalletValue = latestAmountWallet.current ?? 0;
          const amountExtracredit = parseFloat(
            (latestAmountToPayWithExtracredit.current || 0).toFixed(2)
          );
          const amountBankTransferValue = parseFloat(
            (latestAmountBankTransfer.current || 0).toFixed(2)
          );
          const amountCash = parseFloat(
            (
              totalOrder -
              amountWalletValue -
              amountExtracredit -
              amountBankTransferValue
            ).toFixed(2)
          );

          console.log("FINISH ORDER - PayPal");
          console.log("Total Order:", totalOrder);
          console.log("Amount Wallet:", amountWalletValue);
          console.log("Amount Extracredit:", amountExtracredit);
          console.log("Amount Bank Transfer:", amountBankTransferValue);
          console.log("amountcash:", amountCash);
          console.log("Soma:", amountWalletValue + amountExtracredit + amountBankTransferValue + amountCash);

          res = await orderService.postFinishOrder(
            localStorage.getItem("__extraconomy_token"),
            localStorage.getItem("__extraconomy_username"),
            address,
            amountCash,
            amountWalletValue,
            amountExtracredit,
            amountBankTransferValue,
            props?.bankTransferReceipt,
            city,
            country,
            district,
            order?.id,
            number,
            postalCode,
            state,
            transactionID
          );
        }

        if (res.messageCode === 200000) {
          localStorage.removeItem(orderKey);
          clearCart();
          setDisplayPaymentModal(false);
          setIsPaying(false);
          setIsProcessingPayment(false);
          setPage(4);

          try {
            const timeout = new Promise((_, reject) =>
              setTimeout(() => reject(new Error("sendPurchase timeout")), 5000)
            );
            await Promise.race([sendPurchase(), timeout]);
          } catch (sendPurchaseError) {
          }
        } else {
          const errorMessage = localeText("data")?.find((msg) => msg.code === res.messageCode);
          toast?.current?.show?.({
            severity: "error",
            summary: localeText("error"),
            detail: errorMessage?.message || `${localeText("errorOfSystem")} (Código: ${res.messageCode})`,
            life: 6000,
          });
          setPage(5);
          props.setLoading(false);
          setIsPaying(false);
          setIsProcessingPayment(false);
          return false;
        }
      } catch (e) {
        if (e.status === 401 || e.status === 403) {
          removelocalStorageToken();
          removelocalStorageUsername();
          Navigate.push("/login");
        }
        props.setLoading(false);
        setIsPaying(false);
        setIsProcessingPayment(false);
        return false;
      }
    },
    [
      props,
      isFringeBenefitsPage,
      orderKey,
      orderService,
      amountWallet,
      order?.id,
      price,
      toast,
      setDisplayPaymentModal,
      Navigate,
      setPage,
      address,
      city,
      country,
      district,
      number,
      postalCode,
      state,
      clearCart,
      getUserInfoService,
      integrationService,
      userCurrency,
      latestAmountWallet,
      latestAmountToPayWithExtracredit,
      latestAmountBankTransfer,
      calculateTotalPrice,
    ]
  );

  const createOrder = useCallback(async () => {
    try {
      const currentPrice = latestPrice.current;
      if (!currentPrice || currentPrice <= 0) {
        return false;
      }

      const payload = {
        amount: currentPrice,
        currency: "EUR",
        returnUrl: "https://example.com/success",
        cancelUrl: "https://example.com/cancel",
      };

      const res = await advancedPayPalService.createOrder(payload);

      if (!res || !res.id) {
        return false;
      }

      orderId.current = res.id;
      return res.id;
    } catch (e) {
      return false;
    }
  }, [advancedPayPalService]);

  const onApprove = async (data, actions) => {
    try {
      setIsPaying(true);
      setIsProcessingPayment(true);

      const totalOrder = calculateTotalPrice();
      const amountWalletValue = latestAmountWallet.current ?? 0;
      const amountExtracredit = parseFloat(
        (latestAmountToPayWithExtracredit.current || 0).toFixed(2)
      );
      const amountBankTransferValue = parseFloat(
        (latestAmountBankTransfer.current || 0).toFixed(2)
      );

      const amountCash = parseFloat(
        (
          totalOrder -
          amountWalletValue -
          amountExtracredit -
          amountBankTransferValue
        ).toFixed(2)
      );

      console.log("VALIDATEBEFOREFINISH - PayPal");
      console.log("Total Order:", totalOrder);
      console.log("Amount Wallet:", amountWalletValue);
      console.log("Amount Extracredit:", amountExtracredit);
      console.log("Amount Bank Transfer:", amountBankTransferValue);
      console.log("Amount Cash (PayPal):", amountCash);
      console.log("Soma:", amountWalletValue + amountExtracredit + amountBankTransferValue + amountCash);

      const validationRes = await orderService.validateBeforeFinish(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username"),
        address,
        amountCash,
        amountWalletValue,
        amountExtracredit,
        amountBankTransferValue,
        props?.bankTransferReceipt,
        city,
        country,
        district,
        order?.id,
        number,
        postalCode,
        state
      );

      if (!String(validationRes.messageCode).startsWith("2")) {
        const errorMessage = localeText("data")?.find((msg) => msg.code === validationRes.messageCode);
        toast?.current?.show?.({
          severity: "error",
          summary: localeText("paymentSubmissionFailed"),
          detail: errorMessage?.message || localeText("pleaseTryAgain"),
          life: 6000,
        });
        props.setLoading(false);
        setIsPaying(false);
        setIsProcessingPayment(false);
        setPage(5);
        return false;
      }

      console.log("Validação OK");
      const captureRes = await advancedPayPalService.captureOrder(orderId.current);

      setIdTransaction(captureRes.id);

      console.log("Pagamento capturado", captureRes.id);
      await finishOrder(captureRes.id);

      return data;
    } catch (err) {
      console.error("Erro no onApprove:", err);
      toast?.current?.show?.({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("unexpectedErrorTransaction"),
        life: 6000,
      });
      setIsPaying(false);
      setIsProcessingPayment(false);
      props.setLoading(false);
      setPage(5);
      return false;
    }
  };

  return (
    <>
      {(price > 0 || initialPrice.current > 0 || isPaying || isProcessingPayment) && (
        <div style={{ position: 'relative' }}>
          <PayPalButtons
            disabled={isPaying || isProcessingPayment}
            fundingSource="paypal"
            options={{ currency: "EUR" }}
            createOrder={createOrder}
            onApprove={onApprove}
            onError={(err) => {
              toast?.current?.show?.({
                severity: "error",
                summary: localeText("error"),
                detail: localeText("unexpectedErrorTransaction"),
                life: 6000,
              });
            }}
          />
          {(isPaying || isProcessingPayment) && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '4px',
                zIndex: 10,
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  color: '#0070ba',
                  fontWeight: 'bold',
                }}
              >
                <div
                  style={{
                    width: '20px',
                    height: '20px',
                    border: '2px solid #0070ba',
                    borderTop: '2px solid transparent',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                  }}
                />
                {localeText("processingPayment")}
              </div>
            </div>
          )}
        </div>
      )}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </>
  );
};

export default PayPalButtonsOnly;
